import { defineMessages, MessageDescriptor } from 'react-intl';

/**
 * Entity name messages for "Create {entity}" button (user, group, station, fragments).
 * Use with formatMessage so the extractor picks up the ids and defaultMessages.
 */
export const entityMessages: Record<string, MessageDescriptor> = defineMessages({
  user: {
    id: 'common.entities.user',
    defaultMessage: 'usuario',
  },
  group: {
    id: 'common.entities.group',
    defaultMessage: 'grupo',
  },
  station: {
    id: 'common.entities.station',
    defaultMessage: 'emisora',
  },
  fragments: {
    id: 'common.entities.fragments',
    defaultMessage: 'fragmentos',
  },
});
